// import Vue from "vue";
import Router from "vue-router";
const index = () => import("@/components/index");
const nav = () => import("@/components/nav"); //
const login = () => import("@/components/login"); //登录
const User = () => import("@/components/User"); //用户
const Role = () => import("@/components/Role"); //角色管理
// const PopScreen = () => import("@/components/PopScreen1");
const PopScreen = () => import("@/components/PopScreen");
const ServiceArchives = () => import("@/components/ServiceArchives"); //客户档案
const VehicleFiles = () => import("@/components/VehicleFiles"); //车辆档案
const FileDetails = () => import("@/components/FileDetails"); //车辆档案详情
const CommunicationHistory = () => import("@/components/CommunicationHistory"); //车辆档案详情
const VehicleDetails = () => import("@/components/VehicleDetails"); //车辆详情
const UserGroup = () => import("@/components/UserGroup"); //用户组管理
const RedBlackList = () => import("@/components/RedBlackList"); //红黑名单管理
const VehicleConfiguration = () => import("@/components/VehicleConfiguration"); //车型配置表
const PartsPrice = () => import("@/components/PartsPrice"); //配置价格表
const SmsTemplate = () => import("@/components/SmsTemplate"); //短信模板
const ServiceProvider = () => import("@/components/ServiceProvider"); //服务商
const Work0rderVisit = () => import("@/components/Work0rderVisit"); //工单回访
const CustomerSSIvisit = () => import("@/components/CustomerSSIvisit"); //新客户ssi回访
const FiveYearsCustomerSubstitution = () =>
  import("@/components/FiveYearsCustomerSubstitution"); //5年保客置换
const FullGuestResearch = () => import("@/components/FullGuestResearch"); //饱客类调研
const TemporaryBusinessResearch = () =>
  import("@/components/TemporaryBusinessResearch"); //临时业务调研
const Configuration = () => import("@/components/Configuration"); //配置项管理
const apply = () => import("@/components/apply"); //离席申请
const HorseRaceLamp = () => import("@/components/HorseRaceLamp"); //跑马灯管理
const MainEnginePlant = () => import("@/components/MainEnginePlant"); //主机厂部门管理
const Station = () => import("@/components/Station"); //工位设置
const ShortMessage = () => import("@/components/ShortMessage"); //工位设置
const Questionnaire = () => import("@/components/Questionnaire"); //调研问卷
// const Newcustomers = () => import("@/components/Newcustomers1"); //新客户
const Newcustomers = () => import("@/components/Newcustomers"); //新客户
const WorkorderList = () => import("@/components/WorkorderList"); //工单列表
const Workorderhandle = () => import("@/components/Workorderhandle"); //工单处理
const Report = () => import("@/components/Report"); //报备
const Recording = () => import("@/components/Recording"); //录单
const WorkOrderReturnVisitTask = () =>
  import("@/components/WorkOrderReturnVisitTask"); //工单回访
const RescueInput = () => import("@/components/RescueInput"); //救援工单录入
const ReturnVisitResults = () => import("@/components/ReturnVisitResults"); //填写回访结果
const ToPendingList = () => import("@/components/ToPendingList"); //待处理
const Notice = () => import("@/components/Notice"); //通知
const ClueOutbound = () => import("@/components/ClueOutbound"); //线索外呼
const BaokeExcavate = () => import("@/components/BaokeExcavate"); //保客挖掘
const DefeatActivation = () => import("@/components/DefeatActivation"); //战败激活
const ClueOutboundTask = () => import("@/components/ClueOutboundTask"); //战败激活
const ClueOutboundDetails = () => import("@/components/ClueOutboundDetails"); //战败激活详情
const BaokeExcavateTask = () => import("@/components/BaokeExcavateTask"); //保客挖掘
const BaokeExcavateDetails = () => import("@/components/BaokeExcavateDetails"); //保客挖掘详情
const DefeatActivationTask = () => import("@/components/DefeatActivationTask"); //战败激活
const DefeatActivationDetails = () =>
  import("@/components/DefeatActivationDetails"); //战败激活详情
const CustomerSSIvisitTask = () => import("@/components/CustomerSSIvisitTask"); //新客户ssi回访
const FiveYearsCustomerSubstitutionTask = () =>
  import("@/components/FiveYearsCustomerSubstitutionTask"); //5年保客置换
const CustomerSSIvisitDetails = () =>
  import("@/components/CustomerSSIvisitDetails"); //新客户ssi回访详情
const FiveYearsCustomerSubstitutionDetails = () =>
  import("@/components/FiveYearsCustomerSubstitutionDetails"); //5年保客置换详情
const ClubPoliteTask = () => import("@/components/ClubPoliteTask"); //俱乐部留资有礼
const ClubPoliteDetails = () => import("@/components/ClubPoliteDetails"); //俱乐部留资有礼详情
const RecommendCarTask = () => import("@/components/RecommendCarTask"); //俱乐部推荐用车
const RecommendCarDetails = () => import("@/components/RecommendCarDetails"); //俱乐部推荐用车详情
const AppointmentReturnVisitTask = () =>
  import("@/components/AppointmentReturnVisitTask"); //俱乐部预约回访
const AppointmentReturnVisitDetails = () =>
  import("@/components/AppointmentReturnVisitDetails"); //俱乐部推荐用车详情
const BacknetworkcheckTask = () => import("@/components/BacknetworkcheckTask"); //退网核查
const BacknetworkcheckDetails = () =>
  import("@/components/BacknetworkcheckDetails"); //退网核查详情
const SubstitutioncheckTask = () =>
  import("@/components/SubstitutioncheckTask"); //置换核查
const SubstitutioncheckDetails = () =>
  import("@/components/SubstitutioncheckDetails"); //置换核查详情
const TemporaryBusinessTask = () =>
  import("@/components/TemporaryBusinessTask"); //临时业务
const TemporaryBusinessDetails = () =>
  import("@/components/TemporaryBusinessDetails"); //临时业务详情
const WorkOrderReport = () => import("@/components/WorkOrderReport"); //工单全字段报表
const TodayWorkOrderReport = () => import("@/components/TodayWorkOrderReport"); //今日工单全字段报表
const GuoJinWorkOrderReport = () => import("@/components/GuoJinWorkOrderReport"); //国金工单全字段报表
const TwoHoursReport = () => import("@/components/TwoHoursReport"); //2小时回复率报表
const CustomerProfileReport = () =>
  import("@/components/CustomerProfileReport"); //客户档案报表
const OBResultReport = () => import("@/components/OBResultReport"); //外呼结果报表
const CCLeadsReports = () => import("@/components/CCLeadsReports"); //外呼结果报表
const QueryNoNotificationNumCarRepo = () =>
  import("@/components/QueryNoNotificationNumCarRepo"); //无公告号车辆查询报表
const CommunicationHistoryAll = () =>
  import("@/components/CommunicationHistoryAll"); //下拉菜单沟通历史查询
const CustomerProfileReportAllBrand = () =>
  import("@/components/CustomerProfileReportAllBrand"); //全品牌车辆详情报表
const OneToThreeBaokeCust = () => import("@/components/OneToThreeBaokeCust"); //外呼任务管理- 1到3月保客回访
const OneToThreeBaokeCustTask = () =>
  import("@/components/OneToThreeBaokeCustTask"); //外呼任务- 1到3月保客回访
const terminalBadReview = () => import("@/components/terminalBadReview"); // 终端差评
const OneToThreeBaokeCustDetails = () =>
  import("@/components/OneToThreeBaokeCustDetails");
const RealSaleReport = () => import("@/components/RealSaleReport"); //报表- 商务车实销查询
const CSICustomer = () => import("@/components/CSICustomer"); //商务车-CSI客户回访
const CSICustomerTask = () => import("@/components/CSICustomerTask"); //商务车-CSI客户回访
const CSICustomerDetails = () => import("@/components/CSICustomerDetails"); //商务车-CSI客户回访
const NoNotifyNumAllReport = () => import("@/components/NoNotifyNumAllReport"); //无公告号车辆报表-全品牌
const WarrantyRecommend = () => import("@/components/WarrantyRecommend"); //外呼任务管理- 延保推荐
const WarrantyRecommendTask = () =>
  import("@/components/WarrantyRecommendTask"); //外呼任务- 延保推荐
const WarrantyRecommendDetails = () =>
  import("@/components/WarrantyRecommendDetails");

const ActualSalesReport = () => import("@/components/ActualSalesReport"); // 实销报表
const RemindReport = () => import("@/components/RemindReport"); // 催单报表
const WorkOrderFollow = () => import("@/components/WorkOrderFollow"); // 项目跟进单列表
const WorkOrderFollowDetail = () => import("@/components/WorkOrderFollowDetail"); // 项目跟进单详情
const PublicOpinion = () => import("@/components/PublicOpinion"); // 公关舆情任务
// Vue.use(Router);
//解决同一个路由被多次添加
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

const router = new Router({
  // mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [
    {
      path: "/",
      name: "login",
      component: login,
      redirect: "login",
      children: [
        {
          path: "/login",
          name: "login",
          component: login
        }
      ]
    },
    {
      path: "/nav",
      name: "nav",
      component: nav,
      redirect: "/index",
      children: [
        {
          path: "/index",
          name: "index",
          component: index
        },
        {
          path: "/User",
          name: "User",
          component: User
        },
        {
          path: "/Role",
          name: "Role",
          component: Role
        },
        // {
        //   path: '/PopScreen',
        //   name: 'PopScreen',
        //   component: PopScreen,
        // },
        {
          path: "/PopScreen/:id",
          props: true,
          name: "PopScreen",
          component: PopScreen
        },
        {
          path: "/ServiceArchives",
          name: "ServiceArchives",
          component: ServiceArchives
        },
        {
          path: "/VehicleFiles",
          name: "VehicleFiles",
          component: VehicleFiles
        },
        {
          path: "/FileDetails",
          name: "FileDetails",
          component: FileDetails
        },
        {
          path: "/CommunicationHistory",
          name: "CommunicationHistory",
          component: CommunicationHistory
        },
        {
          path: "/VehicleDetails",
          name: "VehicleDetails",
          component: VehicleDetails
        },
        {
          path: "/ClueOutbound",
          name: "ClueOutbound",
          component: ClueOutbound
        },
        {
          path: "/UserGroup",
          name: "UserGroup",
          component: UserGroup
        },
        {
          path: "/RedBlackList",
          name: "RedBlackList",
          component: RedBlackList
        },
        {
          path: "/VehicleConfiguration",
          name: "VehicleConfiguration",
          component: VehicleConfiguration
        },
        {
          path: "/PartsPrice",
          name: "PartsPrice",
          component: PartsPrice
        },
        {
          path: "/SmsTemplate",
          name: "SmsTemplate",
          component: SmsTemplate
        },
        {
          path: "/ServiceProvider",
          name: "ServiceProvider",
          component: ServiceProvider
        },
        {
          path: "/Work0rderVisit",
          name: "Work0rderVisit",
          component: Work0rderVisit
        },
        {
          path: "/CustomerSSIvisit",
          name: "CustomerSSIvisit",
          component: CustomerSSIvisit
        },
        {
          path: "/FiveYearsCustomerSubstitution",
          name: "FiveYearsCustomerSubstitution",
          component: FiveYearsCustomerSubstitution
        },
        {
          path: "/FullGuestResearch",
          name: "FullGuestResearch",
          component: FullGuestResearch
        },
        {
          path: "/TemporaryBusinessResearch",
          name: "TemporaryBusinessResearch",
          component: TemporaryBusinessResearch
        },
        {
          path: "/Configuration",
          name: "Configuration",
          component: Configuration
        },
        {
          path: "/apply",
          name: "apply",
          component: apply
        },
        {
          path: "/HorseRaceLamp",
          name: "HorseRaceLamp",
          component: HorseRaceLamp
        },
        {
          path: "/MainEnginePlant",
          name: "MainEnginePlant",
          component: MainEnginePlant
        },
        {
          path: "/Station",
          name: "Station",
          component: Station
        },
        {
          path: "/ShortMessage",
          name: "ShortMessage",
          component: ShortMessage
        },
        {
          path: "/Questionnaire",
          name: "Questionnaire",
          component: Questionnaire
        },

        {
          path: "/Newcustomers/:id",
          name: "Newcustomers",
          props: true,
          component: Newcustomers
        },
        {
          path: "/WorkorderList",
          name: "WorkorderList",
          component: WorkorderList
        },
        {
          path: "/Workorderhandle",
          name: "Workorderhandle",
          component: Workorderhandle
        },
        {
          path: "/Report",
          name: "Report",
          component: Report
        },
        {
          path: "/Recording",
          name: "Recording",
          component: Recording,
          meta: {
            title: "录单",
            keepAlive: true
          }
        },
        {
          path: "/WorkOrderReturnVisitTask",
          name: "WorkOrderReturnVisitTask",
          component: WorkOrderReturnVisitTask
        },

        {
          path: "/RescueInput",
          name: "RescueInput",
          component: RescueInput
        },
        {
          path: "/ReturnVisitResults",
          name: "ReturnVisitResults",
          component: ReturnVisitResults
        },
        {
          path: "/ToPendingList",
          name: "ToPendingList",
          component: ToPendingList
        },
        {
          path: "/Notice",
          name: "Notice",
          component: Notice
        },
        {
          path: "/BaokeExcavate",
          name: "BaokeExcavate",
          component: BaokeExcavate
        },
        {
          path: "/DefeatActivation",
          name: "DefeatActivation",
          component: DefeatActivation
        },
        {
          path: "/ClueOutboundTask",
          name: "ClueOutboundTask",
          component: ClueOutboundTask
        },
        {
          path: "/ClueOutboundDetails",
          name: "ClueOutboundDetails",
          component: ClueOutboundDetails
        },
        {
          path: "/BaokeExcavateTask",
          name: "BaokeExcavateTask",
          component: BaokeExcavateTask
        },
        {
          path: "/BaokeExcavateDetails",
          name: "BaokeExcavateDetails",
          component: BaokeExcavateDetails
        },
        {
          path: "/DefeatActivationTask",
          name: "DefeatActivationTask",
          component: DefeatActivationTask
        },
        {
          path: "/DefeatActivationDetails",
          name: "DefeatActivationDetails",
          component: DefeatActivationDetails
        },
        {
          path: "/CustomerSSIvisitTask",
          name: "CustomerSSIvisitTask",
          component: CustomerSSIvisitTask
        },
        {
          path: "/CustomerSSIvisitDetails",
          name: "CustomerSSIvisitDetails",
          component: CustomerSSIvisitDetails
        },
        ,
        {
          path: "/FiveYearsCustomerSubstitutionDetails",
          name: "FiveYearsCustomerSubstitutionDetails",
          component: FiveYearsCustomerSubstitutionDetails
        },
        {
          path: "/FiveYearsCustomerSubstitutionTask",
          name: "FiveYearsCustomerSubstitutionTask",
          component: FiveYearsCustomerSubstitutionTask
        },
        {
          path: "/ClubPoliteTask",
          name: "ClubPoliteTask",
          component: ClubPoliteTask
        },
        {
          path: "/ClubPoliteDetails",
          name: "ClubPoliteDetails",
          component: ClubPoliteDetails
        },
        {
          path: "/RecommendCarTask",
          name: "RecommendCarTask",
          component: RecommendCarTask
        },
        {
          path: "/RecommendCarDetails",
          name: "RecommendCarDetails",
          component: RecommendCarDetails
        },
        {
          path: "/AppointmentReturnVisitTask",
          name: "AppointmentReturnVisitTask",
          component: AppointmentReturnVisitTask
        },
        {
          path: "/AppointmentReturnVisitDetails",
          name: "AppointmentReturnVisitDetails",
          component: AppointmentReturnVisitDetails
        },
        {
          path: "/BacknetworkcheckTask",
          name: "BacknetworkcheckTask",
          component: BacknetworkcheckTask
        },
        {
          path: "/BacknetworkcheckDetails",
          name: "BacknetworkcheckDetails",
          component: BacknetworkcheckDetails
        },
        {
          path: "/SubstitutioncheckTask",
          name: "SubstitutioncheckTask",
          component: SubstitutioncheckTask
        },
        {
          path: "/SubstitutioncheckDetails",
          name: "SubstitutioncheckDetails",
          component: SubstitutioncheckDetails
        },
        {
          path: "/TemporaryBusinessTask",
          name: "TemporaryBusinessTask",
          component: TemporaryBusinessTask
        },
        {
          path: "/TemporaryBusinessDetails",
          name: "TemporaryBusinessDetails",
          component: TemporaryBusinessDetails
        },
        {
          path: "/WorkOrderReport",
          name: "WorkOrderReport",
          component: WorkOrderReport
        },
        {
          path: "/TodayWorkOrderReport",
          name: "TodayWorkOrderReport",
          component: TodayWorkOrderReport
        },
        {
          path: "/GuoJinWorkOrderReport",
          name: "GuoJinWorkOrderReport",
          component: GuoJinWorkOrderReport
        },
        {
          path: "/TwoHoursReport",
          name: "TwoHoursReport",
          component: TwoHoursReport
        },
        {
          path: "/CustomerProfileReport",
          name: "CustomerProfileReport",
          component: CustomerProfileReport
        },
        {
          path: "/OBResultReport",
          name: "OBResultReport",
          component: OBResultReport
        },
        {
          path: "/CCLeadsReports",
          name: "CCLeadsReports",
          component: CCLeadsReports
        },
        {
          path: "/QueryNoNotificationNumCarRepo",
          name: "QueryNoNotificationNumCarRepo",
          component: QueryNoNotificationNumCarRepo
        },
        {
          path: "/RealSaleReport",
          name: "RealSaleReport",
          component: RealSaleReport
        },
        {
          path: "/CommunicationHistoryAll",
          name: "CommunicationHistoryAll",
          component: CommunicationHistoryAll
        },
        {
          path: "/CustomerProfileReportAllBrand",
          name: "CustomerProfileReportAllBrand",
          component: CustomerProfileReportAllBrand
        },
        {
          path: "/OneToThreeBaokeCust",
          name: "OneToThreeBaokeCust",
          component: OneToThreeBaokeCust
        },
        {
          path: "/OneToThreeBaokeCustTask",
          name: "OneToThreeBaokeCustTask",
          component: OneToThreeBaokeCustTask
        },
        {
          path: "/terminalBadReview",
          name: "terminalBadReview",
          component: terminalBadReview
        },
        {
          path: "/OneToThreeBaokeCustDetails",
          name: "OneToThreeBaokeCustDetails",
          component: OneToThreeBaokeCustDetails
        },
        {
          path: "/CSICustomer",
          name: "CSICustomer",
          component: CSICustomer
        },
        {
          path: "/CSICustomerTask",
          name: "CSICustomerTask",
          component: CSICustomerTask
        },
        {
          path: "/CSICustomerDetails",
          name: "CSICustomerDetails",
          component: CSICustomerDetails
        },
        {
          path: "/NoNotifyNumAllReport",
          name: "NoNotifyNumAllReport",
          component: NoNotifyNumAllReport
        },
        {
          path: "/WarrantyRecommend",
          name: "WarrantyRecommend",
          component: WarrantyRecommend
        },
        {
          path: "/WarrantyRecommendTask",
          name: "WarrantyRecommendTask",
          component: WarrantyRecommendTask
        },
        {
          path: "/WarrantyRecommendDetails",
          name: "WarrantyRecommendDetails",
          component: WarrantyRecommendDetails
        },
        {
          path: "/ActualSalesReport",
          name: "ActualSalesReport",
          component: ActualSalesReport
        },
        {
          path: "/RemindReport",
          name: "RemindReport",
          component: RemindReport
        },
        {
          path: "/WorkOrderFollow",
          name: "WorkOrderFollow",
          component: WorkOrderFollow
        },
        {
          path: "/WorkOrderFollowDetail",
          name: "WorkOrderFollowDetail",
          component: WorkOrderFollowDetail
        },
        {
          path: "/PublicOpinion",
          name: "PublicOpinion",
          component: PublicOpinion
        },
      ]
    }
  ]
});

// -------- 路由越权访问拦截（beforeEach 全局守卫） --------

// 判定一个路由是否是"菜单入口"（vs 详情页/子页面/动态路由）
// 菜单入口才需要严格的 authorities 权限校验，详情页/子页面已登录即可
function isMenuEntryPath(path) {
  if (!path) return false;
  // 带 :参数 的动态路由 → 不是菜单入口
  if (/:\\w+/.test(path)) return false;
  // 详情页（结尾带这些后缀）→ 不是菜单入口
  if (/Details?$/.test(path)) return false;          // Details / Detail
  if (/handle$/i.test(path)) return false;           // handle / Handle
  if (/Results?$/.test(path)) return false;          // Results / Result
  if (/FollowDetail$/.test(path)) return false;      // FollowDetail（注意：不是 Follow）
  // 任务页（以 Task 结尾）→ 不是菜单入口
  if (/Task$/.test(path)) return false;
  // 报表页（以 Report / Reports 结尾）→ 不是菜单入口（从菜单入口进入后直接放行）
  if (/Reports?$/.test(path)) return false;
  return true;
}

// 从路由配置中递归收集所有"菜单级路由"的 path
// 详情页、任务页、动态路由被 isMenuEntryPath 过滤掉
const menuLevelRoutePaths = new Set();
function collectMenuLevelPaths(routes) {
  if (!Array.isArray(routes)) return;
  routes.forEach(function (r) {
    if (r.path && isMenuEntryPath(r.path)) {
      menuLevelRoutePaths.add(r.path);
    }
    if (r.children) collectMenuLevelPaths(r.children);
  });
}
collectMenuLevelPaths(router.options.routes);

// 硬编码白名单：authorities 菜单树里**没有 path 字段**但路由表里存在的合法入口
// 典型场景：后端给某些菜单项只配了 label/children 没配 path（"通知"/"知识库"/"质检"等）
// 这些路由跳过 authorities 白名单校验 → 只要已登录即放行
// 注：详情页/子页面（以 Details/handle/Report 等结尾）已被 isMenuEntryPath 过滤，
//     不在 menuLevelRoutePaths 里，根本不会走到这里，无需再列
const authorityUntrackedRoutes = new Set([
  '/Notice',         // "通知"菜单 - authorities 里无 path
  '/apply',          // 申请
  '/HorseRaceLamp',  // 跑马灯
  '/Questionnaire',  // 问卷
  '/PublicOpinion',  // 舆情
]);

// 开发期辅助：延迟打印"菜单级路由有但 authorities 里没 path"的候选路径
// 用轮询解决模块加载时 authorities 还没登录存进 sessionStorage 的时机问题
(function scheduleUntrackedDiagnosis() {
  var checked = false;
  var timer = setInterval(function () {
    var a = getAuthorities();
    if (a) {
      clearInterval(timer);
      checked = true;
      try {
        var allowed = extractAllowedPaths(a);
        var missing = [];
        menuLevelRoutePaths.forEach(function (p) {
          if (!allowed.has(p) && !authorityUntrackedRoutes.has(p)) missing.push(p);
        });
        if (missing.length) {
          // eslint-disable-next-line no-console
          console.info('[路由守卫] 菜单级路由存在但 authorities 未追踪的路径（可按需加入 authorityUntrackedRoutes）:\n  ',missing.join(', ')
          );
        } else {
          // eslint-disable-next-line no-console
          console.info('[路由守卫] ✓ 所有菜单级路由均已在 authorities 白名单中');
        }
      } catch (e) {}
    }
  }, 500);
  // 最长等 60s 后放弃（防止用户不登录也一直轮询）
  setTimeout(function () {
    if (!checked) clearInterval(timer);
  }, 60000);
})();

// 从多个存储位置按优先级尝试获取 authorities 权限树
// login.vue 存储全景：
//   sessionStorage 'userinfo'    = res.data.data       → .authorities  (nav.vue 实际使用来源)
//   localStorage  'userInfo'    = res.data             → .data.authorities
//   localStorage  'authorities' = res.data.authorities → 直接就是权限树
function getAuthorities() {
  // 优先级 1：sessionStorage.userinfo.authorities（nav.vue 在用的来源）
  var raw1 = sessionStorage.getItem('userinfo');
  if (raw1) {
    try {
      var u1 = JSON.parse(raw1);
      if (Array.isArray(u1 && u1.authorities)) return u1.authorities;
    } catch (e) {}
  }
  // 优先级 2：localStorage.userInfo.data.authorities
  var raw2 = localStorage.getItem('userInfo');
  if (raw2) {
    try {
      var u2 = JSON.parse(raw2);
      if (u2 && u2.data && Array.isArray(u2.data.authorities)) return u2.data.authorities;
      if (Array.isArray(u2 && u2.authorities)) return u2.authorities;
    } catch (e) {}
  }
  // 优先级 3：localStorage.authorities（login.vue 第 802 行独立存的一份）
  var raw3 = localStorage.getItem('authorities');
  if (raw3) {
    try {
      var u3 = JSON.parse(raw3);
      if (Array.isArray(u3)) return u3;
    } catch (e) {}
  }
  return null;
}

// 递归从 authorities 树里提取所有"有 path 字段"的菜单项，组成路径白名单 Set
// 数据结构示例：
//   [
//     { path: "/index", children: [ { path: "/ToPendingList", ... }, { label: "通知", ... } ] },
//     { children: [ { path: "/ServiceArchives", children: [...] } ] }
//   ]
// 注意：叶子按钮节点（"保存"/"修改"等）没有 path 字段，被自然跳过
function extractAllowedPaths(authorities) {
  var paths = new Set();
  function walk(nodes) {
    if (!Array.isArray(nodes)) return;
    nodes.forEach(function (node) {
      if (node && node.path) paths.add(node.path);
      if (node && Array.isArray(node.children)) walk(node.children);
    });
  }
  walk(authorities);
  return paths;
}

router.beforeEach(function (to, from, next) {
  // 1) 白名单：登录页、根路径 直接放行
  if (to.path === '/login' || to.path === '/' || to.path === '') {
    next();
    return;
  }

  // 2) Token 校验（sessionStorage 优先，localStorage 兜底）
  var userToken = sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
  if (!userToken) {
    next('/login');
    return;
  }

  // 3) 动态路由前缀匹配：把 /Newcustomers/123 → /Newcustomers 再判断
  //    这样 /PopScreen/:id、/Newcustomers/:id 这种带参数的路由也能找到对应的父级菜单
  var checkPath = to.path;
  var matchedMenuPrefix = null;

  if (menuLevelRoutePaths.has(checkPath)) {
    // 完全命中菜单级路由 → 就是菜单入口本身
    matchedMenuPrefix = checkPath;
  } else {
    // 尝试前缀匹配（从最精细到最粗）
    var segs = checkPath.split('/').filter(Boolean);
    for (var i = segs.length; i >= 1; i--) {
      var prefix = '/' + segs.slice(0, i).join('/');
      if (menuLevelRoutePaths.has(prefix)) {
        matchedMenuPrefix = prefix;
        break;
      }
    }
  }

  if (matchedMenuPrefix) {
    // 当前访问的路径属于某个菜单级路由（或其子路由/动态路由）→ 进入权限校验
    var authorities = getAuthorities();
    if (!authorities) {
      // 权限树完全丢失 → 踢回登录页让用户重新登录
      console.warn('[路由守卫] authorities 为空，踢回登录页');
      next('/login');
      return;
    }

    // 0) 先查硬编码白名单：authority 未追踪但合法的路由
    if (authorityUntrackedRoutes.has(matchedMenuPrefix)) {
      next();
      return;
    }

    var allowedPaths = extractAllowedPaths(authorities);

    // 1) 权限系统追踪此路由且用户有权限 → 放行
    if (allowedPaths.has(matchedMenuPrefix)) {
      next();
    } else {
      // 2) 权限系统追踪此路由但用户无权限 → 拦截
      console.warn('[路由守卫] 用户无权访问路径:', to.path, ' (所需菜单:', matchedMenuPrefix, ')');
      // 防止死循环：如果已经是 index 却又被拒绝，直接踢回登录页
      next(matchedMenuPrefix === '/index' ? '/login' : '/index');
    }
    return;
  }

  // 4) 既不是菜单入口也不是任何菜单的子路由（比如纯详情页 /ClueOutboundDetails 这种
  //    不在菜单树但合法的子页面）—— 只要已登录就放行
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js